import { FormikConsumer } from 'formik';
import type { FormikContextType } from 'formik';
import React, { useEffect } from 'react';

interface IScrollToErrorProps {
  fieldName: string;
  fieldRef: any;
}

export function ScrollToFormikError(props: IScrollToErrorProps) {
  return (
    <FormikConsumer>
      {(formikBag) => (formikBag ? (
        <ScrollToFormikErrorEffect formikBag={formikBag} fieldName={props.fieldName} fieldRef={props.fieldRef} />
      ) : null)}
    </FormikConsumer>
  );
}

function ScrollToFormikErrorEffect({
  formikBag,
  fieldName,
  fieldRef
}: {
  formikBag: FormikContextType<any>;
  fieldName: string;
  fieldRef: any;
}) {
  useEffect(() => {
    const firstError = Object.keys(formikBag.errors || {})[0];
    if (formikBag.isSubmitting && firstError === fieldName) {
      fieldRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [formikBag.isSubmitting, formikBag.errors, fieldName, fieldRef]);
  return null;
}
